import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap-5';

import UnstyledDropdownToggle from 'components/bootstrap_extensions/bs5/unstyled_dropdown_toggle';

export default function FloorPlanRow({ floorPlan, onDelete, onReplace }) {
  const photoPreviewStyle = {
    backgroundImage: `url(${floorPlan.thumbnailUrl})`
  };

  // TODO: Eventually if we decide this needs to be a card or something later, we can use mediaUiUpdate to show new UI
  const oldPhotoRowBody = () => {
    return (
      <div className="old-media-tab">
        <div className="photo-row shadow-sm mb-2" name="floor-plan-container">
          <div className="row">
            <div className="col-3">
              <div className="js-photo-preview" style={photoPreviewStyle}></div>
            </div>
            <div className="col-9">
              <div className="photo-inputs-container">
                <div className="photo-inputs">
                  <div className="row">
                    <div className="col-9"></div>
                    <div className="col-3 col-lg-3 text-center">
                      <Dropdown className="photo-options" id={floorPlan.id || floorPlan.uploadId}>
                        <Dropdown.Toggle
                          as={UnstyledDropdownToggle}
                          id={`floor-plan-${floorPlan.id || floorPlan.uploadId}`}
                        >
                          <i className="fas fa-ellipsis-v fa-lg text-muted clickable settings-icon" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="photoOptions">
                          <Dropdown.Item
                            name="deletePlanButton"
                            onClick={onDelete}
                          >
                            Delete
                          </Dropdown.Item>
                          <Dropdown.Item
                            name="replacePlanButton"
                            onClick={onReplace}
                          >
                            Replace Plan
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      { oldPhotoRowBody() }
    </React.Fragment>
  );
}

FloorPlanRow.propTypes = {
  floorPlan: PropTypes.shape({
    id: PropTypes.number,
    uploadId: PropTypes.number,
    thumbnailUrl: PropTypes.string
  }),
  onDelete: PropTypes.func.isRequired,
  onReplace: PropTypes.func.isRequired
};
